<template>
    <div class="vertical-nav">
        <div class="vertical-nav--title">{{ $t('fu-wu-yu-zhi-chi') }}</div>
        <el-menu
            mode="vertical"
            :default-active="activePath"
            :router="true"
            :default-openeds="subMenus"
        >
            <template
                v-for="submenus in menus"
            >
                <el-submenu
                    v-if="submenus.children && submenus.children.length > 0"
                    :key="submenus.key"
                    :index="submenus.key"
                >
                    <template slot="title">
                        <el-badge
                            v-if="submenus.badge"
                            slot="title"
                            :value="submenus.badgeValue"
                        >
                            <span>{{ submenus.name }}</span>
                        </el-badge>
                        <span
                            v-else
                            slot="title"
                        >
                            {{ submenus.name }}
                        </span>
                    </template>
                    <el-menu-item
                        v-for="menu in submenus.children"
                        :key="menu.key"
                        v-track="{
                            category: '菜单列表',
                            name: '菜单点击数统计',
                            value: menu.zhName,
                        }"
                        :index="menu.path"
                    >
                        <template slot="title">
                            <el-badge
                                v-if="menu.badge"
                                slot="title"
                                :value="menu.badgeValue"
                            >
                                <span>{{ menu.name }}</span>
                            </el-badge>
                            <span
                                v-else
                                slot="title"
                            >
                                {{ menu.name }}
                            </span>
                        </template>
                    </el-menu-item>
                </el-submenu>
                <el-menu-item
                    v-else
                    :key="submenus.key"
                    v-track="{
                        category: '菜单列表',
                        name: '菜单点击数统计',
                        value: submenus.zhName,
                    }"
                    :index="submenus.path"
                >
                    <template slot="title">
                        <el-badge
                            v-if="submenus.badge"
                            slot="title"
                            :value="submenus.badgeValue"
                        >
                            <span>{{ submenus.name }}</span>
                        </el-badge>
                        <span
                            v-else
                            slot="title"
                        >
                            {{ submenus.name }}
                        </span>
                    </template>
                </el-menu-item>
            </template>
        </el-menu>
    </div>
</template>

<script lang="ts">
import {
    Component,
    Vue,
    Watch,
} from 'vue-property-decorator';

@Component
export default class LeftNav extends Vue {
    menus:any = [];
    activePath = '';
    subMenus = [];

    @Watch('$route.path')
    onPathChange() {
        this.setActivePath();
    }

    mounted() {
        this.menus = [
            {
                key: 'createTicket',
                name: this.$t('chuang-jian-gong-dan'),
                zhName: '创建工单',
                path: '/ticket/create',
            },
            {
                key: 'ticketList',
                name: this.$t('gong-dan-lie-biao'),
                zhName: '工单列表',
                path: '/ticket/list',
            },
            {
                key: 'authList',
                name: this.$t('shou-quan-lie-biao'),
                zhName: '授权列表',
                path: '/auth/list',
            },
        ];
        if (!this.$i18n.locale.includes('en')) {
            this.menus.unshift({
                key: 'assistant',
                name: this.$t('zhi-neng-zhu-shou'),
                zhName: '智能助手',
                path: '/ticket/assistant',
            });
        }
        // 设置当前activePath
        this.setActivePath();
    }
    // 设置当前activePath
    setActivePath() {
        const {path} = this.$route;
        this.activePath = path;
    }
}
</script>
<style lang="scss">
@import '@/common/var.scss';

.vertical-nav {
    overflow: hidden;
    .vertical-nav--title {
        height: 50px;
        line-height: 50px;
        font-size: 14px;
        border-bottom: $border-default;
        padding: 0 16px;
        text-align: left;
        font-weight: 600;
        color: $--color-input;
    }

    .el-menu {
        border: none;

        .el-badge {
            height: 40px;
            line-height: 40px;
        }

        .el-badge__content {
            top: 19px;
            right: -10px;
        }

        .el-menu-item {
            text-align: left;

            * {
                vertical-align: baseline;
            }
        }
    }
}
</style>
